import React from 'react';
import { Empty } from 'antd';
import { Retry } from '@components/common';
import DimensionCombination from './DimensionGroup/DimensionCombination';
import { AllDimensionList, PointerIconRing, ListWrapper, dimensionCustomCss } from './styled';
import DimensionGroup from './DimensionGroup';
import { useGlobalFeature } from '@src/globalStore/globalFeatureFlagsStore';
import { globalFeatureNames } from '@src/utils/featureToggle/constants';

// TODO: remove after custom dimension for DPI is released, this is kept for rollback purposes
function AIDimensionsLegacy({ isLoading, isFetching, data }) {
  const { aiAlertsConfig = [], customerRootCauseType = null } = data ?? {
    aiAlertsConfig: [],
    customerRootCauseType: null,
  };
  const isEmptyData = !isFetching && (aiAlertsConfig?.[0]?.totalCombinations || 0) === 0;
  const levelZeroComb = aiAlertsConfig[0]?.dimensionData;

  return (
    <Retry isLoading={isLoading} mountChildAlways={false}>
      {isEmptyData ? (
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          style={{ margin: '100px auto' }}
          description={
            <div>
              There is not enough data right now to show the AI Cohort combinations. <br />
              Please try after the account has enough data.
            </div>
          }
        />
      ) : (
        <AllDimensionList>
          <ListWrapper>
            <PointerIconRing margin="20px 18px 20px 11px" />
            <DimensionCombination
              customCss={dimensionCustomCss}
              combinations={levelZeroComb}
              level={0}
            />
          </ListWrapper>
          <DimensionGroup aiConfigList={aiAlertsConfig} customerType={customerRootCauseType} />
        </AllDimensionList>
      )}
    </Retry>
  );
}

function AIDimensionsWithDrawer({ data }) {
  const { aiAlertsConfig = [], customerRootCauseType = null } = data ?? {
    aiAlertsConfig: [],
    customerRootCauseType: null,
  };
  const isEmptyData = (aiAlertsConfig?.[0]?.totalCombinations || 0) === 0;
  const levelZeroComb = aiAlertsConfig[0]?.dimensionData;

  if (isEmptyData) {
    return (
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        style={{ margin: '100px auto' }}
        description={
          <div>
            There is not enough data right now to show the AI Cohort combinations. <br />
            Please try after the account has enough data.
          </div>
        }
      />
    );
  }

  return (
    <AllDimensionList>
      <ListWrapper>
        <PointerIconRing margin="20px 18px 20px 11px" />
        <DimensionCombination
          customCss={dimensionCustomCss}
          combinations={levelZeroComb}
          level={0}
        />
      </ListWrapper>
      <DimensionGroup aiConfigList={aiAlertsConfig} customerType={customerRootCauseType} />
    </AllDimensionList>
  );
}

export default function AIDimensions({ isLoading, isFetching, data }) {
  const enableDPICustomDimesion = useGlobalFeature(globalFeatureNames.DPI_CUSTOM_DIMENSION);

  return enableDPICustomDimesion ? (
    <AIDimensionsWithDrawer data={data} />
  ) : (
    <AIDimensionsLegacy isLoading={isLoading} isFetching={isFetching} data={data} />
  );
}
